import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
	selector: 'toggle-switch',
	templateUrl: './toggle-switch.component.html',
	styleUrls: ['./toggle-switch.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class ToggleSwitchComponent {
	@Input() id: string;

	@Input() on: boolean;

	@Input() className: string;

	@Input() form: UntypedFormGroup;

	@Input() label: string;
}
